<script setup>
  import ComponentRange from "@components/Inputs/Range.vue";
  import PatientinputComponentStep from "@pages/Patientinput/Components/Step.vue";

  defineOptions({
    name: "PatientinputComponentStepCompliance",
  });

  defineProps({
    form: {
      type: Object,
      required: true,
    },
  });

  const confidentDatalist = ["nicht sicher", "sehr sicher"];
  const forgottenDatalist = ["noch nie", "sehr oft"];
  const affectDatalist = ["überhaupt nicht", "völlig"];
  const painDatalist = ["kein Schmerz", "stärkster vorstellbarer Schmerz"];
</script>

<template>
  <PatientinputComponentStep title="Wie geht es Ihnen im Alltag?" :test-id="getTestId()">
    <ComponentRange
      v-model="form.compliance.confident"
      min="1"
      max="5"
      label="Wie sicher fühlen Sie sich im Umgang mit Ihrer Medikation?"
      :datalist="confidentDatalist"
      :test-id="getTestId('compliance-step-confident')"
    />

    <ComponentRange
      v-model="form.compliance.forgotten"
      min="1"
      max="5"
      label="Jeder von uns hat schon mal etwas vergessen. Haben Sie schonmal die Einnahme Ihrer Medikamente vergessen?"
      :datalist="forgottenDatalist"
      :test-id="getTestId('compliance-step-forgotten')"
    />

    <ComponentRange
      v-model="form.compliance.affect"
      min="1"
      max="5"
      label="Wie sehr wird Ihr Alltag durch die Einnahme/Anwendung Ihrer Medikamente beeinträchtigt?"
      :datalist="affectDatalist"
      :test-id="getTestId('compliance-step-affect')"
    />

    <ComponentRange
      v-model="form.compliance.pain"
      min="0"
      max="10"
      label="Falls Sie unter Schmerzen leiden, wie stark sind diese im Durchschnitt auf einer Skala von 0 (= kein Schmerz) bis 10 (= stärkster vorstellbarer Schmerz)?"
      :datalist="painDatalist"
      show-value
      :test-id="getTestId('compliance-step-pain')"
    />
  </PatientinputComponentStep>
</template>
